// extracted by css-extract-rspack-plugin
export default {"shimmer":"shimmer-JWiloQ","shimmer-animation":"shimmer-animation-e82kN7","shimmerAnimation":"shimmer-animation-e82kN7"};